export enum DocumentSourceTypeEnum {
    File = 'file',
    Link = 'link',
}
